import Agent from './Agent';
import AssistedLiving from './AssistedLiving';
import MemberExtended from './MemberExtended';
import Office from './Office';
import Photo from './Photo';

export { Agent, AssistedLiving, MemberExtended, Office, Photo };

export default {
  Agent,
  AssistedLiving,
  MemberExtended,
  Office,
  Photo
};



// WEBPACK FOOTER //
// ./src/records/index.js